import { useEffect, useState } from "react";
import { RefreshCw, CheckCircle2, XCircle, AlertTriangle } from "lucide-react";
import { AdminShell } from "../../components/admin/AdminShell";
import { adminFetch } from "../../lib/adminApi";

const ICON = {
  PASS: <CheckCircle2 className="w-4 h-4 text-emerald-300 shrink-0" />,
  FAIL: <XCircle className="w-4 h-4 text-signal-red shrink-0" />,
  WARN: <AlertTriangle className="w-4 h-4 text-yellow-300 shrink-0" />,
};

const AdminReadinessPage = () => (
  <AdminShell title="Go-Live Readiness"><ReadinessView /></AdminShell>
);

const ReadinessView = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true); setError("");
    try { setData(await adminFetch("/api/admin/readiness")); } catch (e) { setError(e.message); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="readiness-view">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <p className="text-gray-400 text-sm">Read-only diagnostic of the Stripe, tax, shipping and email configuration this deployment is running with. No charges are made.</p>
        <button type="button" onClick={load} className="inline-flex items-center gap-2 px-4 py-2.5 border border-white/20 text-gray-200 text-sm hover:border-signal-red" data-testid="readiness-refresh"><RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} /> Re-run</button>
      </div>
      {error && <p className="text-signal-red text-sm mb-3" data-testid="readiness-error">{error}</p>}
      {data && (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6 font-mono text-xs">
            <Stat label="Stripe mode" value={data.stripe_mode} testid="readiness-stripe-mode" />
            <Stat label="Key mode" value={data.key_mode} testid="readiness-key-mode" />
            <Stat label="Commerce" value={data.commerce_enabled ? "ENABLED" : "disabled"} testid="readiness-commerce" />
            <Stat label="Blocking failures" value={String(data.blocking_failures.length)} testid="readiness-blocking-count" />
          </div>
          <ul className="divide-y divide-white/10 border border-white/10" data-testid="readiness-list">
            {data.checks.map((c) => (
              <li key={c.check} className="flex items-start gap-3 px-4 py-3" data-testid={`readiness-${c.check}`}>
                {ICON[c.status]}
                <div className="min-w-0">
                  <p className="text-white text-sm font-mono">{c.check} <span className="text-gray-500">· {c.status}</span></p>
                  <p className="text-gray-400 text-xs break-words">{c.detail}</p>
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

const Stat = ({ label, value, testid }) => (
  <div className="bg-[#141414] border border-white/10 px-4 py-3" data-testid={testid}>
    <p className="text-gray-500 uppercase tracking-widest">{label}</p>
    <p className="text-white text-base mt-1">{value}</p>
  </div>
);

export default AdminReadinessPage;
